export default __webpack_public_path__ + "images/34d3795cccaf8cdb9b732703f7dab7e9-badge-thrive-progress.svg";